import { render, staticRenderFns } from "./ModalRulesPopup.vue?vue&type=template&id=297971a5"
import script from "./ModalRulesPopup.vue?vue&type=script&lang=js"
export * from "./ModalRulesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports